<script>
import AdminPanel from '@components/admin-panel/admin-panel.vue';
import CircuitForm from '@components/forms/circuit-form.vue';
import ExerciseList from '@components/exercise/exercise-list.vue';
import Layout from '@layouts/main.vue';
import WorkoutDetail from '@components/workout/workout-detail.vue';
import WorkoutList from '@components/workout/workout-list.vue';
import UseLargeScreen from '@components/use-large-screen.vue';
import { adminPanelMixin } from '@mixins/admin-panel-mixin';
import { circuitModelMixin } from '@mixins/models/circuit-model-mixin';
import { breakpointsMixin } from '@mixins/breakpoints-mixin.js';
import { helperMixin } from '@mixins/helper-mixin';
import {
  authComputed,
  adminPanelComputed,
  adminPanelMethods,
  circuitComputed,
  circuitMethods,
  workoutComputed,
  workoutMethods,
} from '@state/helpers';

export default {
  page: {
    title: 'Workout Detail',
    meta: [{ name: 'description', content: 'The Workout Detail page.' }],
  },
  props: {
    workout: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: {
    AdminPanel,
    CircuitForm,
    ExerciseList,
    Layout,
    WorkoutDetail,
    WorkoutList,
    UseLargeScreen,
  },
  mixins: [adminPanelMixin, circuitModelMixin, helperMixin, breakpointsMixin],
  data() {
    return {};
  },
  computed: {
    ...adminPanelComputed,
    ...authComputed,
    ...circuitComputed,
    ...workoutComputed,
  },
  mounted() {},
  destroyed() {
    this.$_clearSelections();
  },
  methods: {
    ...adminPanelMethods,
    ...circuitMethods,
    ...workoutMethods,
    async showAdminPanel(component, data = null, size = '') {
      await this.setPanelContent(this.getPanelContent(component, data, size));
      this.setShowAdminPanel();
    },
    onSelectCircuitItem(circuit) {
      this.setAddWorkoutCircuit(circuit);
      this.setHideAdminPanel();
      this.setSelectedCircuit(null);
    },
    onSelectExerciseItem(exercise) {
      this.setAddWorkoutCircuitExercise({
        exercise: exercise,
        defaultSet: [this.getCircuitExerciseSetModel()],
        circuitIndex: this.panelContent.data.selectedCircuitIndex,
      });
      this.setHideAdminPanel();
    },
  },
};
</script>

<template>
  <UseLargeScreen v-if="isSmallScreenView" />
  <Layout v-else>
    <AdminPanel
      :title="panelContent ? panelContent.title : ''"
      :size="panelContent ? panelContent.size : ''"
      :noPad="true"
    >
      <component
        v-if="panelContent"
        :is="panelContent.component"
        :content="panelContent"
        :showWorkoutFilters="
          panelContent && panelContent.data
            ? panelContent.data.showWorkoutFilters
            : false
        "
        :showExerciseFilters="true"
        @select-circuit-item="onSelectCircuitItem"
        @select-exercise-item="onSelectExerciseItem"
      />
    </AdminPanel>

    <div class="container-wrapper full dark" ref="contentWrapper">
      <WorkoutDetail :workout="workout" />
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.container-wrapper {
  padding-bottom: 20rem;

  .set-card-container {
    height: auto;
    padding: 2rem 3rem;
  }
}

.add-new-circuit-wrapper {
  display: flex;
  justify-content: center;
}

// stylelint-disable selector-pseudo-element-no-unknown
::v-deep .workout-circuit {
  .exercise-title ~ .row {
    padding-left: 0;
  }
  .rep-controls {
    margin: 0 auto;
  }
  .exercise-set-details {
    .exercise-set-details-header {
      padding-bottom: 1rem;
      text-align: center;
      .col {
        padding: 0;
      }
    }
  }
  .card-circuit-header {
    .rep-counter {
      .rep-icon-wrapper {
        background-color: rgba($color-medium-gray-wo-rgb, 0.3);
        &:hover {
          background-color: rgba($color-medium-gray-wo-rgb, 0.5);
        }
      }
    }
  }
  .set-controls {
    padding: 0;
    .set-num {
      margin: 0 1rem;
    }
  }
}
</style>
